import { http } from '@/api/http'
import type { ProcurementBatchDocument, ProcurementBatchDocumentFolder, ProcurementBatchDocuments } from '@/types/api'
import type { RequestOptions } from '../crud'

const documents = (batchId: string) => `/procurement/batches/${encodeURIComponent(batchId)}/documents`

/**
 * «Документы» of an invoice (client 2026-11-04): folders and files of one
 * Batch. Reading needs procurement_batches.read, every change .update.
 */
export const batchDocumentsService = {
  async list(batchId: string, options?: RequestOptions) {
    const { data } = await http.get<ProcurementBatchDocuments>(documents(batchId), options)
    return { batch_id: data.batch_id, folders: data.folders ?? [], files: data.files ?? [] }
  },
  async createFolder(batchId: string, body: { name: string; parent_id: string }) {
    const { data } = await http.post<ProcurementBatchDocumentFolder>(`${documents(batchId)}/folders`, body)
    return data
  },
  async updateFolder(batchId: string, id: string, body: { name?: string; parent_id?: string }) {
    const { data } = await http.patch<ProcurementBatchDocumentFolder>(`${documents(batchId)}/folders/${encodeURIComponent(id)}`, body)
    return data
  },
  async removeFolder(batchId: string, id: string) {
    await http.delete(`${documents(batchId)}/folders/${encodeURIComponent(id)}`)
  },
  /** One file per request, stored like POST /file-upload and recorded in the folder ("" = the root). */
  async upload(batchId: string, folderId: string, file: File, onProgress?: (percent: number) => void) {
    const form = new FormData()
    form.append('file', file)
    form.append('folder_id', folderId)
    const { data } = await http.post<ProcurementBatchDocument>(`${documents(batchId)}/files`, form, {
      onUploadProgress: (event) => {
        if (onProgress && event.total) onProgress(Math.round((event.loaded / event.total) * 100))
      },
    })
    return data
  },
  async updateFile(batchId: string, id: string, body: { name?: string; folder_id?: string }) {
    const { data } = await http.patch<ProcurementBatchDocument>(`${documents(batchId)}/files/${encodeURIComponent(id)}`, body)
    return data
  },
  async removeFile(batchId: string, id: string) {
    await http.delete(`${documents(batchId)}/files/${encodeURIComponent(id)}`)
  },
}
